type BenefitType = {
  title: string
  text: string
  imageName: string
}[]

export const BENEFITS: BenefitType = [
  {
    title:
      'Coding helps develop <span class="text-orange">problem-solving skills</span>',
    text:
      'Through coding, a child learns how to identify a problem statement and then develop an app, website or a code to solve these problems. ',
    imageName: 'problem-solving',
  },
  {
    title:
      'Coding helps develop <span class="text-orange">analytical thinking</span>',
    text:
      'In programming, kids learn how to "handle errors" - that is to anticipate problems that will probably emerge, and then writing the correct codes that will prevent the problems from happening  or correcting the code when the error happens.',
    imageName: 'analytical-thinking',
  },
  {
    title:
      'Coding helps develop <span class="text-orange">structural thinking</span>',
    text:
      'Coding helps a child learn how to build small pieces of codes and then get these different blocks of codes to work together teaching them how to think structurally.',
    imageName: 'structural-thinking',
  },
  {
    title:
      'Coding simplifies complex <span class="text-orange">math concepts</span>',
    text:
      "It's a misconception that only someone who's good at math can code. In fact, Coding shows practical application of math concepts and kids learn how to use mathematical concepts in a problem to move it forward.",
    imageName: 'math-concepts',
  },
  {
    title: 'Coding helps <span class="text-orange">develop resilience</span>',
    text:
      'The act of debugging a problem in coding teaches kids resilience. They learn how to test multiple solutions of solving a problem if one way does not work.',
    imageName: 'develop-resilience',
  },
]
